export default __webpack_public_path__ + "static/media/supplierTrav.d951e1c2.png";